<div id="clienteditor" class="clienteditor-component" data-hook="clienteditor-component">
    <form name="clientedit" autocomplete="noway">
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <!-- Testpatient -->
                <div class="form-group">
                    <label for="testpat"
                           style="-webkit-column-break-inside: avoid; page-break-inside: avoid; break-inside: avoid;">
                        Status
                        <sprhelp tip="Status" descref="vm.testhelp" style="display: inline"></sprhelp>
                    </label>
                    <div class="form-group">
                        <label for="testpat" class="checkbox-inline">
                            <input type="checkbox" id="testpat" ng-change="vm.save()" tabindex="0"
                                   ng-model="vm.client.test"/> {{vm.testkunde}}</label>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <!-- ist Firma -->
                <div class="form-group">
                    <label for="testpat">Organsiation</label>
                    <div class="form-group">
                        <label for="iscompany" class="checkbox-inline">
                            <input type="checkbox" id="iscompany"
                                   ng-change="vm.save()" tabindex="0"
                                   ng-model="vm.client.iscompany"/> Organisation/Firma</label>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <!-- Kundenkatgorie -->
                <div class="form-group">
                    <label for="clientcat"
                           style="-webkit-column-break-inside: avoid; page-break-inside: avoid; break-inside: avoid;">Kundenkategorie
                        <sprhelp tip="Kundenkategorie" descref="vm.clientcathelp" style="display: inline"></sprhelp>
                    </label>
                    <input type="text" class="form-control" tabindex="0"
                           ng-blur="vm.save()"
                           ng-show="angular.isUndefined(vm.clientcategories) || !angular.isArray(vm.clientcategories)"
                           id="clientcat" name="clientcat" ng-model="vm.client.category">
                    <select class="form-control" tabindex="0"
                            ng-show="angular.isDefined(vm.clientcategories) && vm.clientcategories.length > 0"
                            id="clientcat" name="clientcat" ng-model="vm.client.category"
                    >
                        <option ng-repeat="cat in vm.clientcategories" value="cat" ng-click="vm.save()">{{cat}}</option>
                    </select>
                </div>
            </div>

        </div>

        <companyedit companydata="vm.client.companydata"
                     parentsave="vm.childsave()"
                     ng-show="vm.client.iscompany === true"></companyedit>


        <contactedit contactdata="vm.client.primarycontact"
                     parentsave="vm.childsave()"></contactedit>

        <svedit svdata="vm.client.svdata"
                parentsave="vm.childsave()"
                ng-show="vm.mode === 'patient'"></svedit>

        <riskedit risk="vm.client.risk"
                  parentsave="vm.childsave()"
                  ng-show="vm.mode === 'patient'"></riskedit>


        <div class="spacer-top spacer-bottom">
            <button class="btn btn-success" ng-click="vm.addContact()"><i class="fa fa-plus"></i> Neuen Ansprechpartner
                anlegen
            </button>
        </div>

        <div ng-show="vm.client.contacts.length > 0">
            <h3>Ansprechpartner</h3>

            <div class="panel panel-info" ng-repeat="contact in vm.client.contacts | orderBy:'-'">
                <div class="panel-heading">
        <span ng-show="contact.lastname">
          <span ng-bind="contact.firstname"> </span>
          <span ng-bind="contact.lastname"> </span>
        </span>
                    <span ng-hide="contact.lastname">Neuer Kontakt</span>
                </div>
                <div class="panel-body">
                    <contactedit contactdata="contact" parentsave="vm.childsave()" showrelation="true"></contactedit>
                </div>
            </div>

        </div>
    </form>
</div>